import { Component } from 'react';
import { Container, ListGroup } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';

import './CourseList.css';
import apiClient from "../../../framework/web/ApiClient";

interface Course {
    courseId: number,
    courseCode: string;
    courseName: string;
    courseUrl: string;
    passingScore: number;
}

interface State {
    courses: Course[];
    loading: boolean;
    error: string | null;
}

const PAGE_TITLE = "AMS - Course";

class CourseList extends Component<{}, State> {

    constructor(props: {}) {
        super(props);
        this.state = {
            courses: [],
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        document.title = PAGE_TITLE;
        this.fetchAllCourses();
    }

    fetchAllCourses = async () => {
        const headers = {
            'Access-Control-Allow-Origin': '*',
            "Content-Type": "application/json"
        };
        apiClient.get('/ams/api/v1/researcher-trainings/courses', { withCredentials: true, headers })
            .then(response => {
                if (response.status != 204) {
                    this.setState({ courses: response.data.data, loading: false });
                }
            }).catch(error => {
                this.setState({ error: 'Error fetching questions', loading: false });
            });
    };

    render() {
        const { courses, loading, error } = this.state;

        if (loading) {
            return <div>Loading...</div>;
        }

        if (error) {
            return <div>{error}</div>;
        }

        return (
           <Container fluid>
              <h2 className="d-block mb-4">Researcher Training Course</h2>
              <h6>Please select a course below.</h6>
              <div className="constrained-left">
                 <ListGroup as="ol" numbered>
                    {courses.filter(c => c.courseUrl !== null).map((course, index) => (
                       <ListGroup.Item as="li" key={course.courseId} action className="d-flex">
                          <NavLink to={`/course/${course.courseId}`} className="nav-link">
                             &nbsp;{course.courseName}
                          </NavLink>
                       </ListGroup.Item>
                    ))}
                 </ListGroup>
              </div>
           </Container>
        )
    };
}

export default CourseList;
